import Vue from "vue";
import vuetify from '@/plugins/vuetify';
import VPreview from "./index";

export default function(index, originVue) {
    document.querySelector("#media-preview")?.remove?.();
    const div = document.createElement("div");
    const el = document.createElement("div");
    div.id = "media-preview";
    div.appendChild(el);
    document.body.appendChild(div);

    let instance = null;

    function render() {
        instance = new Vue({
            el,
            vuetify,
            components: {
                VPreview
            },
            data() {
                return {
                    isShow: false
                };
            },
            created() {
                this.$nextTick(() => {
                    this.isShow = true;
                    document.body.classList.add("disabled-scroll");
                });
            },
            methods: {
                on_close() {
                    setTimeout(() => {
                        this.isShow = false;
                        document.body.classList.remove("disabled-scroll");
                    }, 100);
                },
                on_destroy() {
                    instance.$destroy();
                    instance = null;
                    div.remove();
                }
            },
            render() {
                return (
                    <transition name="fade" vOn:after-leave={this.on_destroy}>
                        {this.isShow ? (
                            <VPreview
                                index={index}
                                originVue={originVue}
                                vOn:close={this.on_close}
                            />
                        ) : null}
                    </transition>
                );
            }
        });
    }
    render();
}
